import { makeStyles } from '@material-ui/core/styles'
import { Switch } from '@material-ui/core'
import CustomDatePicker from 'src/components/BuyPolicy/common/CustomDatePicker'
import dayjs from 'dayjs'
import { NO, YES } from 'src/utils/constants/BuyPolicy'

const ExpiryPopOver = ({ isExpired, formOne, closePopover }) => {
  const classes = useStyles()

  const getMinDate = () => {
    return dayjs().startOf('day')
  }

  const getMaxDate = () => {
    return dayjs().subtract(1, 'day').startOf('day')
  }

  return (
    <>
      <div className={classes.overAllContainer}>
        <div className={classes.expiredContainer}>
          {isExpired ? (
            <div className={classes.expiredContainer}>
              <div className={classes.expiredAction}>
                <span className={classes.expiredContent}>
                  When does your policy expire?
                </span>
              </div>
              <div>
                <CustomDatePicker
                  id='policy-expiry'
                  name='expiryDate'
                  placeholder='Policy Expiry Date *'
                  minimumDate={isExpired ? getMinDate() : null}
                  value={formOne?.values?.expiryDate}
                  onChange={(event) => {
                    formOne.handleChange(event)
                  }}
                  className={classes.expiryDatePick}
                  closePopover={closePopover}
                />
              </div>
            </div>
          ) : (
            <>
              <div className={classes.notExpiredAction}>
                <div className={classes.notExpiredContent}>
                  Did your policy expire after 26th April 2023?
                </div>
                <div>
                  <Switch
                    classes={{
                      root: classes.switchRoot,
                      switchBase: classes.switchBase,
                      thumb: classes.thumb,
                      track: classes.track,
                      checked: classes.checked,
                    }}
                    checked={formOne?.values?.isPolicyExpiredBeforeDate === YES}
                    onChange={(e) => {
                      formOne.setFieldValue(
                        'isPolicyExpiredBeforeDate',
                        e?.target?.checked ? YES : NO,
                        true
                      )
                    }}
                    name='isPolicyExpiredBeforeDate'
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                </div>
                <div className={classes.toggleButton}>
                  {/* <ToogleButton /> */}
                </div>
              </div>
              <div className={classes.expityDateAction}>
                <span className={classes.expiryDateContent}>
                  Mention the expired date
                </span>
              </div>
              <div>
                <CustomDatePicker
                  id='policy-expired'
                  name='expiredDate'
                  maximumDate={!isExpired ? getMaxDate() : null}
                  placeholder='Policy Expired Date *'
                  value={formOne?.values?.expiredDate}
                  onChange={(event) => {
                    formOne.handleChange(event)
                  }}
                  className={classes.expiryDatePick}
                  closePopover={closePopover}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default ExpiryPopOver
const useStyles = makeStyles({
  expiredContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    gap: 10,
  },
  expiryDatePick: {
    '&  .MuiOutlinedInput-input': {
      height: '0.3rem',
    },
  },
  notExpiredAction: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },
  notExpiredContent: {
    fontSize: '11px',
    fontWeight: '400',
    fontFamily: 'roboto',
    color: '#636363',
  },
  expiryDateContent: {
    fontSize: '12px',
    fontWeight: '400',
    fontFamily: 'roboto',
    color: '#ACACAC',
  },
  expiredContent: {
    fontSize: '11px',
    fontWeight: '400',
    fontFamily: 'roboto',
  },
  overAllContainer: {
    width: '100%',
  },
  switchRoot: {
    width: '55px',
    height: '24px',
    padding: '0px',
  },
  switchBase: {
    color: '#818181',
    padding: '1px',
    '&$checked': {
      '& + $track': {
        backgroundColor: '#23bf58',
      },
    },
  },
  thumb: {
    color: 'white',
    width: '25px',
    height: '20px',
    margin: '1px',
  },
  track: {
    borderRadius: '20px',
    backgroundColor: '#818181',
    opacity: '1 !important',
    '&:after, &:before': {
      color: 'white',
      fontSize: '11px',
      fontWeight: 500,
      position: 'absolute',
      top: '6px',
    },
    '&:after': {
      content: 'Yes',
      left: '8px',
    },
    '&:before': {
      content: 'No',
      right: '7px',
    },
  },
  checked: {
    color: '#23bf58 !important',
    transform: 'translateX(26px) !important',
  },
})
